
export const OLD = {
  head_f: {
      side: 'Front', name: 'Head Front', image: 'front_head' },
  throat: {
      side: 'Front', name: 'Throat', image: 'front_neck' },
  right_upper_body: {
      side: 'Front', name: 'Right Upper Body (F)', image: 'front_right_upper_body' },
  left_upper_body: {
      side: 'Front', name: 'Left Upper Body (F)', image: 'front_left_upper_body' },
  right_lower_body: {
      side: 'Front', name: 'Right Lower Body (F)', image: 'front_right_lower_body' },
  left_lower_body: {
      side: 'Front', name: 'Left Lower Body (F)', image: 'front_left_lower_body' },
  right_upper_arm_f: {
      side: 'Front', name: 'Right Upper Arm (F)', image: 'front_right_upper_arm' },
  left_upper_arm_f: {
      side: 'Front', name: 'Left Upper Arm (F)', image: 'front_left_upper_arm' },
  right_lower_arm_f: {
      side: 'Front', name: 'Right Lower Arm (F)', image: 'front_right_lower_arm' },
  left_lower_arm_f: {
      side: 'Front', name: 'Left Lower Arm (F)', image: 'front_left_lower_arm' },
  right_hand_f: {
      side: 'Front', name: 'Right Hand (F)', image: 'front_right_hand' },
  left_hand_f: {
      side: 'Front', name: 'Left Hand (F)', image: 'front_left_hand' },
  right_upper_leg_f: {
      side: 'Front', name: 'Right Upper Leg (F)', image: 'front_right_upper_leg' },
  left_upper_leg_f: {
      side: 'Front', name: 'Left Upper Leg (F)', image: 'front_left_upper_leg' },
  left_groin: {
      side: 'Front', name: 'Left Groin', image: 'front_left_groin'},
  right_groin: {
      side: 'Front', name: 'Right Groin', image: 'front_right_groin'},
  right_knee: {
      side: 'Front', name: 'Right Knee', image: 'front_right_knee' },
  left_knee: {
      side: 'Front', name: 'Left Knee', image: 'front_left_knee' },
  right_lower_leg_f: {
      side: 'Front', name: 'Right Lower Leg (F)', image: 'front_right_lower_leg' },
  left_lower_leg_f: {
      side: 'Front', name: 'Left Lower Leg (F)', image: 'front_left_lower_leg' },
  right_foot_f: {
      side: 'Front', name: 'Right Foot (F)', image: 'front_right_foot' },
  left_foot_f: {
      side: 'Front', name: 'Left Foot (F)', image: 'front_left_foot' },
  // back body
  head_b: {
      side: 'Back', name: 'Head Back', image: 'back_head' },
  right_neck: {
      side: 'Back', name: 'Right Neck (B)', image: 'back_right_neck' },
  left_neck: {
      side: 'Back', name: 'Left Neck (B)', image: 'back_left_neck' },
  right_upper_back: {
      side: 'Back', name: 'Right Upper Back (B)', image: 'back_right_upper_back' },
  left_upper_back: {
      side: 'Back', name: 'Left Upper Back (B)', image: 'back_left_upper_back' },
  right_lower_back: {
      side: 'Back', name: 'Right Lower Back (B)', image: 'back_right_lower_back' },
  left_lower_back: {
      side: 'Back', name: 'Left Lower Back (B)', image: 'back_left_lower_back' },
  right_upper_arm_b: {
      side: 'Back', name: 'Right Upper Arm (B)', image: 'back_right_upper_arm' },
  left_upper_arm_b: {
      side: 'Back', name: 'Left Upper Arm (B)', image: 'back_left_upper_arm' },
  right_elbow: {
      side: 'Back', name: 'Right Elbow', image: 'back_right_elbow' },
  left_elbow: {
      side: 'Back', name: 'Left Elbow', image: 'back_left_elbow' },
  right_lower_arm_b: {
      side: 'Back', name: 'Right Lower Arm (B)', image: 'back_right_lower_arm' },
  left_lower_arm_b: {
      side: 'Back', name: 'Left Lower Arm (B)', image: 'back_left_lower_arm' },
  right_hand_b: {
      side: 'Back', name: 'Right Hand (B)', image: 'back_right_hand' },
  left_hand_b: {
      side: 'Back', name: 'Left Hand (B)', image: 'back_left_hand' },
  right_buttock: {
      side: 'Back', name: 'Right Buttocks', image: 'back_right_buttocks' },
  left_buttock: {
      side: 'Back', name: 'Left Buttocks', image: 'back_left_buttocks' },
  right_upper_leg_b: {
      side: 'Back', name: 'Right Upper Leg (B)', image: 'back_right_upper_leg' },
  left_upper_leg_b: {
      side: 'Back', name: 'Left Upper Leg (B)', image: 'back_left_upper_leg' },
  right_lower_leg_b: {
      side: 'Back', name: 'Right Lower Leg (B)', image: 'back_right_lower_leg' },
  left_lower_leg_b: {
      side: 'Back', name: 'Left Lower Leg (B)', image: 'back_left_lower_leg' },
  right_foot_b: {
      side: 'Back', name: 'Right Foot (B)', image: 'back_right_foot' },
  left_foot_b: {
      side: 'Back', name: 'Left Foot (B)', image: 'back_left_foot' }
}


export const GENERAL_LOCATION =  {
    head_f: {
      side: 'Front',
      name: 'Head (F)'
    },
    neck_f: { side: 'Front', name: 'Neck' },
    upper_abdomen: {
      side: 'Front',
      name: 'Upper Abdomen'
    },
    lower_abdomen: {
      side: 'Front',
      name: 'Lower Abdomen'
    },
    right_foot_f: {
      side: 'Front',
      name: 'Right Foot (F)'
    },
    left_foot_f: {
      side: 'Front',
      name: 'Left Foot (F)'
    },
    right_lower_leg_f: {
      side: 'Front',
      name: 'Right Lower Leg (F)'
    },
    right_thigh_f: {
      side: 'Front',
      name: 'Right Thigh (F)'
    },
    right_fingers_f: {
      side: 'Front',
      name: 'Right Fingers (F)'
    },
    right_hand_f: {
      side: 'Front',
      name: 'Right Hand (F)'
    },
    left_hand_f: {
      side: 'Front',
      name: 'Left Hand (F)'
    },
    left_fingers_f: {
      side: 'Front',
      name: 'Left Fingers (F)'
    },
    left_shoulder_f: {
      side: 'Front',
      name: 'Left Shoulder (F)'
    },
    right_shoulder_f: {
      side: 'Front',
      name: 'Right Shoulder (F)'
    },
    right_chest: {
      side: 'Front',
      name: 'Right Chest'
    },
    left_chest: {
      side: 'Front',
      name: 'Left Chest'
    },
    right_upper_arm_f: {
      side: 'Front',
      name: 'Right Upper Arm (F)'
    },
    left_upper_arm_f: {
      side: 'Front',
      name: 'Left Upper Arm (F)'
    },
    left_flank_f: {
      side: 'Front',
      name: 'Left Flank (F)'
    },
    right_flank_f: {
      side: 'Front',
      name: 'Right Flank (F)'
    },
    left_forearm_f: {
      side: 'Front',
      name: 'Left Forearm (F)'
    },
    right_forearm_f: {
      side: 'Front',
      name: 'Right Forearm (F)'
    },
    right_pelvic: {
      side: 'Front',
      name: 'Right Pelvic'
    },
    left_pelvic: {
      side: 'Front',
      name: 'Left Pelvic'
    },
    left_knee_f: {
      side: 'Front',
      name: 'Left Knee (F)'
    },
    right_knee_f: {
      side: 'Front',
      name: 'Right Knee (F)'
    },
    left_lower_leg_f: {
      side: 'Front',
      name: 'Left Lower Leg (F)'
    },
    left_thigh_f: {
      side: 'Front',
      name: 'Left Thigh (F)'
    },
    left_lower_leg_b: {
      side: 'Back',
      name: 'Left Lower Leg (B)'
    },
    right_lower_leg_b: {
      side: 'Back',
      name: 'Right Lower Leg (B)'
    },
    left_thigh_b: {
      side: 'Back',
      name: 'Left Thigh (B)'
    },
    right_thigh_b: {
      side: 'Back',
      name: 'Right Thigh (B)'
    },
    head_b: {
      side: 'Back',
      name: 'Head (B)'
    },
    right_neck_b: {
      side: 'Back',
      name: 'Right Neck (B)'
    },
    left_neck_b: {
      side: 'Back',
      name: 'Left Neck (B)'
    },
    right_buttock: {
      side: 'Back',
      name: 'Right Buttock'
    },
    left_buttock: {
      side: 'Back',
      name: 'Left Buttock'
    },
    left_flank_b: {
      side: 'Back',
      name: 'Left Flank (B)'
    },
    right_flank_b: {
      side: 'Back',
      name: 'Right Flank (B)'
    },
    right_lower_back: {
      side: 'Back',
      name: 'Right Lower Back'
    },
    left_lower_back: {
      side: 'Back',
      name: 'Left Lower Back'
    },
    left_knee_b: {
      side: 'Back',
      name: 'Left Knee (B)'
    },
    right_knee_b: {
      side: 'Back',
      name: 'Right Knee (B)'
    },
    right_foot_b: {
      side: 'Back',
      name: 'Right Foot (B)'
    },
    left_foot_b: {
      side: 'Back',
      name: 'Left Foot (B)'
    },
    right_upper_back: {
      side: 'Back',
      name: 'Right Upper Back'
    },
    left_upper_back: {
      side: 'Back',
      name: 'Left Upper Back'
    },
    left_forearm_b: {
      side: 'Back',
      name: 'Left Forearm (B)'
    },
    right_forearm_b: {
      side: 'Back',
      name: 'Right Forearm (B)'
    },
    left_fingers_b: {
      side: 'Back',
      name: 'Left Fingers (B)'
    },
    right_fingers_b: {
      side: 'Back',
      name: 'Right Fingers (B)'
    },
    right_hand_b: {
      side: 'Back',
      name: 'Right Hand (B)'
    },
    left_hand_b: {
      side: 'Back',
      name: 'Left Hand (B)'
    },
    left_shoulder_b: {
      side: 'Back',
      name: 'Left Shoulder (B)'
    },
    right_shoulder_b: {
      side: 'Back',
      name: 'Right Shoulder (B)'
    },
    right_upper_arm_b: {
      side: 'Back',
      name: 'Right Upper Arm (B)'
    },
    left_upper_arm_b: {
      side: 'Back',
      name: 'Left Upper Arm (B)'
    },
    right_elbow: {
      side: 'Back',
      name: 'Right Elbow'
    },
    left_elbow: {
      side: 'Back',
      name: 'Left Elbow'
    },
    right_mid_back: {
      side: 'Back',
      name: 'Right Mid Back'
    },
    left_mid_back: {
      side: 'Back',
      name: 'Left Mid Back'
    },
  }

export const RASH = {
    head: { side: 'Front', name: 'Head' },
    groin: { side: 'Front', name: 'Groin' },
    chest: { side: 'Front', name: 'Chest' },
    right_foot: { side: 'Front', name: 'Right Foot' },
    left_foot: { side: 'Front', name: 'Left Foot' },
    right_leg_f: { side: 'Front', name: 'Right Leg (F)' },
    left_leg_f: { side: 'Front', name: 'Left Leg (F)' },
    right_arm_f: { side: 'Front', name: 'Right Arm (F)' },
    left_arm_f: { side: 'Front', name: 'Left Arm (F)' },
    stomach: { side: 'Front', name: 'Stomach' },
    right_hand_f: { side: 'Front', name: 'Right Hand (F)' },
    left_hand_f: { side: 'Front', name: 'Left Hand (F)' },
    neck_f: { side: 'Front', name: 'Neck (F)' },
    right_under_arm: { side: 'Front', name: 'Right Under Arm' },
    left_under_arm: { side: 'Front', name: 'Left Under Arm' },
    right_leg_b: { side: 'Back', name: 'Right Leg (B)' },
    left_leg_b: { side: 'Back', name: 'Left Leg (B)' },
    back: { side: 'Back', name: 'Back' },
    neck_b: { side: 'Back', name: 'Neck (B)' },
    glutes_buttock: { side: 'Back', name: 'Glutes (Buttock)' },
    right_arm_b: { side: 'Back', name: 'Right Arm (B)' },
    left_arm_b: { side: 'Back', name: 'Left Arm (B)' },
    right_hand_b: { side: 'Back', name: 'Right Hand (B)' },
    left_hand_b: { side: 'Back', name: 'Left Hand (B)' }
  }


export const SwollenLymphNodes = {
    groin: { side: 'Front', name: 'Groin' },
    left_knee_f: { side: 'Front', name: 'Left Knee (F)' },
    right_knee_f: { side: 'Front', name: 'Right Knee (F)' },
    neck_f: { side: 'Front', name: 'Neck (F)' },
    right_jaw: { side: 'Front', name: 'Right Jaw' },
    left_jaw: { side: 'Front', name: 'Left Jaw' },
    right_axilla: { side: 'Front', name: 'Right Axilla' },
    left_axilla: { side: 'Front', name: 'Left Axilla' },
    right_elbow_crease: { side: 'Front', name: 'Right Elbow Crease' },
    left_elbow_crease: { side: 'Front', name: 'Left Elbow Crease' },
    neck_b: { side: 'Back', name: 'Neck (B)' },
    left_knee_b: { side: 'Back', name: 'Left Knee (B)' },
    right_knee_b: { side: 'Back', name: 'Right Knee (B)' }
  }

export const BreastProblems = {
    right_under_arm: { side: 'Front', name: 'Right Under Arm' },
    left_under_arm: { side: 'Front', name: 'Left Under Arm' },
    left_areola: { side: 'Front', name: 'Left Areola/Nipple' },
    left_lower_inner_quadrant: {
      side: 'Front',
      name: 'Left Lower Inner Quadrant'
    },
    left_lower_outer_quadrant: {
      side: 'Front',
      name: 'Left Lower Outer Quadrant'
    },
    left_upper_inner_quadrant: {
      side: 'Front',
      name: 'Left Upper Inner Quadrant'
    },
    left_upper_outer_quadrant: {
      side: 'Front',
      name: 'Left Upper Outer Quadrant'
    },
    under_collarbone: { side: 'Front', name: 'Under Collarbone' },
    right_areola: { side: 'Front', name: 'Right Areola/Nipple' },
    right_lower_outer_quadrant: {
      side: 'Front',
      name: 'Right Lower Outer Quadrant'
    },
    right_lower_inner_quadrant: {
      side: 'Front',
      name: 'Right Lower Inner Quadrant'
    },
    right_upper_outer_quadrant: {
      side: 'Front',
      name: 'Right Upper Outer Quadrant'
    },
    right_upper_inner_quadrant: {
      side: 'Front',
      name: 'Right Upper Inner Quadrant'
    }
  }


export const Abdomen = {
  right_upper_abdomen: { side: 'Front', name: 'Right Upper Abdomen' },
  left_upper_abdomen: { side: 'Front', name: 'Left Upper Abdomen' },
  pelvic: { side: 'Front', name: 'Pelvic' },
  epigastric_area: { side: 'Front', name: 'Epigastric Area' },
  right_flank_side: { side: 'Front', name: 'Right Flank/Side' },
  left_flank_side: { side: 'Front', name: 'Left Flank/Side' },
  around_belly_button: { side: 'Front', name: 'Around The Belly Button' },
  lower_abdomen: { side: 'Front', name: 'Lower Abdomen' }
}

export const ChestThoracic = {
  right_ribs: { side: 'Front', name: 'Right Ribs' },
  left_ribs: { side: 'Front', name: 'Left Ribs' },
  epigastric_area: { side: 'Front', name: 'Epigastric Area' },
  right_lower_chest: { side: 'Front', name: 'Right Lower Chest' },
  left_lower_chest: { side: 'Front', name: 'Left Lower Chest' },
  right_side_chest: { side: 'Front', name: 'Right Side Chest' },
  left_side_chest: { side: 'Front', name: 'Left Side Chest' },
  center_chest: { side: 'Front', name: 'Center Chest' },
  upper_chest: { side: 'Front', name: 'Upper Chest' },
  right_arm_pit: { side: 'Front', name: 'Right Arm Pit' },
  left_arm_pit: { side: 'Front', name: 'Left Arm Pit' }
}

export const Back = {
  neck: { side: 'Back', name: 'Neck' },
  left_shoulder: { side: 'Back', name: 'Left Shoulder' },
  right_shoulder: { side: 'Back', name: 'Right Shoulder' },
  upper_back: { side: 'Back', name: 'Upper Back' },
  mid_back: { side: 'Back', name: 'Mid Back' }, 
  right_buttock: { side: 'Back', name: 'Right Buttock' },
  left_buttock: { side: 'Back', name: 'Left Buttock' },
  lower_back: { side: 'Back', name: 'Lower Back' },
  left_side_flank: { side: 'Back', name: 'Left Side/Flank' },
  right_side_flank: { side: 'Back', name: 'Right Side/Flank' }
}

export const Hip = {
  left_outer_hip_f: { side: 'Front', name: 'Left Outer Hip (F)' },
  left_inner_hip_f: { side: 'Front', name: 'Left Inner Hip (F)' },
  right_outer_hip_f: { side: 'Front', name: 'Right Outer Hip (F)' },
  right_inner_hip_f: { side: 'Front', name: 'Right Inner Hip (F)' },
  right_outer_thigh_f: { side: 'Front', name: 'Right Outer Thigh (F)' },
  left_outer_thigh_f: { side: 'Front', name: 'Left Outer Thigh (F)' },
  right_thigh_f: { side: 'Front', name: 'Right Thigh (F)' },
  left_thigh_f: { side: 'Front', name: 'Left Thigh (F)' },
  groin: { side: 'Front', name: 'Groin' },

  left_outer_hip_b: { side: 'Back', name: 'Left Outer Hip (B)' },
  right_outer_hip_b: { side: 'Back', name: 'Right Outer Hip (B)' },
  left_buttock_inner_hip: { side: 'Back', name: 'Left Buttock/Inner Hip' },
  right_buttock_inner_hip: { side: 'Back', name: 'Right Buttock/Inner Hip' },
  lower_back: { side: 'Back', name: 'Lower Back' },
  left_thigh_b: { side: 'Back', name: 'Left Thigh (B)' },
  right_thigh_b: { side: 'Back', name: 'Right Thigh (B)' }
}


export const SHOULDER = {
  neck_f: { side: 'Front', name: 'Neck (F)' },
  right_shoulder_f: { side: 'Front', name: 'Right Shoulder (F)' },
  left_shoulder_f: { side: 'Front', name: 'Left Shoulder (F)' },
  upper_chest: { side: 'Front', name: 'Upper Chest' },
  right_upper_arm_f: { side: 'Front', name: 'Right Upper Arm (F)' },
  left_upper_arm_f: { side: 'Front', name: 'Left Upper Arm (F)' },
  collarbone: { side: 'Front', name: 'Collarbone' },
  neck_b: { side: 'Back', name: 'Neck (B)' },
  upper_back: { side: 'Back', name: 'Upper Back' },
  mid_back: { side: 'Back', name: 'Mid Back' },
  left_shoulder_b: { side: 'Back', name: 'Left Shoulder (B)' },
  right_shoulder_b: { side: 'Back', name: 'Right Shoulder (B)' },
  left_upper_arm_b: { side: 'Back', name: 'Left Upper Arm (B)' },
  right_upper_arm_b: { side: 'Back', name: 'Right Upper Arm (B)' }
}

export const ARM = {
  neck_f: { side: 'Front', name: 'Neck (F)' },
  collarbone: { side: 'Front', name: 'Collarbone' },
  right_palm: { side: 'Front', name: 'Right Palm' },
  right_fingers_f: { side: 'Front', name: 'Right Fingers (F)' },
  right_shoulder_f: { side: 'Front', name: 'Right Shoulder (F)' },
  right_upper_arm_f: { side: 'Front', name: 'Right Upper Arm (F)' },
  right_elbow_f: { side: 'Front', name: 'Right Elbow (F)' },
  right_forearm_f: { side: 'Front', name: 'Right Forearm (F)' },
  left_palm: { side: 'Front', name: 'Left Palm' },
  left_fingers_f: { side: 'Front', name: 'Left Fingers (F)' },
  left_shoulder_f: { side: 'Front', name: 'Left Shoulder (F)' },
  left_upper_arm_f: { side: 'Front', name: 'Left Upper Arm (F)' },
  left_elbow_f: { side: 'Front', name: 'Left Elbow (F)' },
  left_forearm_f: { side: 'Front', name: 'Left Forearm (F)' },
  neck_b: { side: 'Back', name: 'Neck (B)' },
  upper_back: {
    side: 'Back',
    name: 'Shoulder Blades/Upper Back'
  },
  left_fingers_b: { side: 'Back', name: 'Left Fingers (B)' },
  left_shoulder_b: { side: 'Back', name: 'Left Shoulder (B)' },
  left_upper_arm_b: { side: 'Back', name: 'Left Upper Arm (B)' },
  left_elbow_b: { side: 'Back', name: 'Left Elbow (B)' },
  left_forearm_b: { side: 'Back', name: 'Left Forearm (B)' },
  right_fingers_b: { side: 'Back', name: 'Right Fingers (B)' },
  right_shoulder_b: { side: 'Back', name: 'Right Shoulder (B)' },
  right_upper_arm_b: { side: 'Back', name: 'Right Upper Arm (B)' },
  right_elbow_b: { side: 'Back', name: 'Right Elbow (B)' },
  right_forearm_b: { side: 'Back', name: 'Right Forearm (B)' },
  right_hand_b: { side: 'Back', name: 'Right Hand' },
  left_hand_b: { side: 'Back', name: 'Left Hand' }
}

export const HAND = {
  thumb_f: { side: 'Front', name: 'Thumb (F)' },
  index_finger_f: { side: 'Front', name: 'Index Finger (F)' },
  middle_finger_f: { side: 'Front', name: 'Middle Finger (F)' },
  ring_finger_f: { side: 'Front', name: 'Ring Finger (F)' },
  pinky_finger_f: { side: 'Front', name: 'Pinky Finger (F)' },
  palm: { side: 'Front', name: 'Palm' },
  wrist_f: { side: 'Front', name: 'Wrist (F)' },
  thumb_b: { side: 'Back', name: 'Thumb (B)' },
  index_finger_b: { side: 'Back', name: 'Index Finger (B)' },
  middle_finger_b: { side: 'Back', name: 'Middle Finger (B)' },
  ring_finger_b: { side: 'Back', name: 'Ring Finger (B)' },
  pinky_finger_b: { side: 'Back', name: 'Pinky Finger (B)' },
  back_of_hand: { side: 'Back', name: 'Back of Hand (Dorsal)' },
  wrist_b: { side: 'Back', name: 'Wrist (B)' }
}

export const HEAD = {
  scalp: { side: 'Front', name: 'Scalp' },
  right_temple: { side: 'Front', name: 'Right Temple' },
  left_temple: { side: 'Front', name: 'Left Temple' },
  forehead: { side: 'Front', name: 'Forehead' },
  around_right_eye: { side: 'Front', name: 'Around Right Eye' },
  around_left_eye: { side: 'Front', name: 'Around Left Eye' },
  right_cheekbone: { side: 'Front', name: 'Right Cheekbone' },
  left_cheekbone: { side: 'Front', name: 'Left Cheekbone' },
  head_b: { side: 'Back', name: 'Head (B)' },
  neck_b: { side: 'Back', name: 'Neck (B)' },
  above_ear_s: { side: 'Side', name: 'Above the Ear' },
  behind_ear_s: { side: 'Side', name: 'Behind the Ear' },
  under_ear_s: { side: 'Side', name: 'Under the Ear' },
  jaw_s: { side: 'Side', name: 'Jaw' }
}

export const LEG = {
  right_upper_thigh_f: { side: 'Front', name: 'Right Upper Thigh (F)' },
  left_upper_thigh_f: { side: 'Front', name: 'Left Upper Thigh (F)' },
  right_lower_thigh_f: { side: 'Front', name: 'Right Lower Thigh (F)' },
  left_lower_thigh_f: { side: 'Front', name: 'Left Lower Thigh (F)' },
  right_ankle_f: { side: 'Front', name: 'Right Ankle (F)' },
  left_ankle_f: { side: 'Front', name: 'Left Ankle (F)' },
  right_toes_f: { side: 'Front', name: 'Right Toes (F)' },
  left_toes_f: { side: 'Front', name: 'Left Toes (F)' },
  pelvic: { side: 'Front', name: 'Pelvic' },
  right_knee_f: { side: 'Front', name: 'Right Knee (F)' },
  left_knee_f: { side: 'Front', name: 'Left Knee (F)' },
  left_lower_leg_f: { side: 'Front', name: 'Left Lower Leg (F)' },
  right_lower_leg_f: { side: 'Front', name: 'Right Lower Leg (F)' },
  right_foot_f: { side: 'Front', name: 'Right Foot (F)' },
  left_foot_f: { side: 'Front', name: 'Left Foot (F)' },
  left_buttock: { side: 'Back', name: 'Left Buttock' },
  right_buttock: { side: 'Back', name: 'Right Buttock' },
  left_upper_thigh_b: { side: 'Back', name: 'Left Upper Thigh (B)' },
  right_upper_thigh_b: { side: 'Back', name: 'Right Upper Thigh (B)' },
  left_lower_thigh_b: { side: 'Back', name: 'Left Lower Thigh (B)' },
  right_lower_thigh_b: { side: 'Back', name: 'Right Lower Thigh (B)' },
  left_knee_b: { side: 'Back', name: 'Left Knee (B)' },
  right_knee_b: { side: 'Back', name: 'Right Knee (B)' },
  left_upper_calf: { side: 'Back', name: 'Left Upper Calf' },
  right_upper_calf: { side: 'Back', name: 'Right Upper Calf' },
  left_lower_calf: { side: 'Back', name: 'Left Lower Calf' },
  right_lower_calf: { side: 'Back', name: 'Right Lower Calf' },
  left_heel: { side: 'Back', name: 'Left Heel' },
  right_heel: { side: 'Back', name: 'Right Heel' }
}

export const KNEE = {
  above_right_knee_f: { side: 'Front', name: 'Above Right Knee (F)' },
  above_left_knee_f: { side: 'Front', name: 'Above Left Knee (F)' },
  right_lateral_knee_f: { side: 'Front', name: 'Right Lateral Knee (F)' },
  left_lateral_knee_f: { side: 'Front', name: 'Left Lateral Knee (F)' },
  right_kneecap: { side: 'Front', name: 'Right Kneecap' },
  left_kneecap: { side: 'Front', name: 'Left Kneecap' },
  right_medial_knee_f: { side: 'Front', name: 'Right Medial Knee (F)' },
  left_medial_knee_f: { side: 'Front', name: 'Left Medial Knee (F)' },
  below_right_knee_f: { side: 'Front', name: 'Below Right Knee (F)' },
  below_left_knee_f: { side: 'Front', name: 'Below Left Knee (F)' },
  right_lower_leg_f: { side: 'Front', name: 'Right Lower Leg (F)' },
  left_lower_leg_f: { side: 'Front', name: 'Left Lower Leg (F)' },
  left_upper_thigh_b: { side: 'Back', name: 'Left Upper Thigh (B)' },
  right_upper_thigh_b: { side: 'Back', name: 'Right Upper Thigh (B)' },
  left_lower_thigh_b: { side: 'Back', name: 'Left Lower Thigh (B)' },
  right_lower_thigh_b: { side: 'Back', name: 'Right Lower Thigh (B)' },
  left_knee_b: { side: 'Back', name: 'Left Knee (B)' },
  right_knee_b: { side: 'Back', name: 'Right Knee (B)' },
  left_upper_calf_b: { side: 'Back', name: 'Left Upper Calf (B)' },
  right_upper_calf_b: { side: 'Back', name: 'Right Upper Calf (B)' },
  left_lower_calf_b: { side: 'Back', name: 'Left Lower Calf (B)' },
  right_lower_calf_b: { side: 'Back', name: 'Right Lower Calf (B)' }
}


export const ANKLE = {
  right_lower_calf: { side: 'Front', name: 'Right Lower Calf' },
  left_lower_calf: { side: 'Front', name: 'Left Lower Calf' },
  above_right_ankle_f: { side: 'Front', name: 'Above Right Ankle (F)' },
  above_left_ankle_f: { side: 'Front', name: 'Above Left Ankle (F)' },
  right_lateral_ankle_f: {
    side: 'Front',
    name: 'Right Lateral Ankle (F)'
  },
  right_anterior_ankle_f: {
    side: 'Front',
    name: 'Right Anterior Ankle (F)'
  },
  right_medial_ankle_f: { side: 'Front', name: 'Right Medial Ankle (F)' },
  right_dorsal_foot_f: { side: 'Front', name: 'Right Dorsal Foot (F)' },
  left_lateral_ankle_f: { side: 'Front', name: 'Left Lateral Ankle (F)' },
  left_anterior_ankle_f: {
    side: 'Front',
    name: 'Left Anterior Ankle (F)'
  },
  left_medial_ankle_f: { side: 'Front', name: 'Left Medial Ankle (F)' },
  left_dorsal_foot_f: { side: 'Front', name: 'Left Dorsal Foot (F)' },
  left_posterior_ankle_b: {
    side: 'Back',
    name: 'Left Posterior Ankle (B)'
  },
  right_posterior_ankle_b: {
    side: 'Back',
    name: 'Right Posterior Ankle (B)'
  },
  left_heel: { side: 'Back', name: 'Left Heel' },
  right_heel: { side: 'Back', name: 'Right Heel' }
}


export const FOOT = {
  right_ankle: { side: 'Front', name: 'Right Ankle' },
  left_ankle: { side: 'Front', name: 'Left Ankle' },
  right_lateral_foot_f: { side: 'Front', name: 'Right Lateral Foot (F)' },
  right_dorsal_foot_f: { side: 'Front', name: 'Right Dorsal Foot (F)' },
  right_medial_foot_f: { side: 'Front', name: 'Right Medial Foot (F)' },
  left_lateral_foot_f: { side: 'Front', name: 'Left Lateral Foot (F)' },
  left_dorsal_foot_f: { side: 'Front', name: 'Left Dorsal Foot (F)' },
  left_medial_foot_f: { side: 'Front', name: 'Left Medial Foot (F)' },
  left_big_toe: { side: 'Back', name: 'Left Big Toe' },
  left_long_toe: { side: 'Back', name: 'Left Long Toe' },
  left_middle_toe: { side: 'Back', name: 'Left Middle Toe' },
  left_ring_toe: { side: 'Back', name: 'Left Ring Toe' },
  left_little_toe: { side: 'Back', name: 'Left Little Toe' },
  right_big_toe: { side: 'Back', name: 'Right Big Toe' },
  right_long_toe: { side: 'Back', name: 'Right Long Toe' },
  right_middle_toe: { side: 'Back', name: 'Right Middle Toe' },
  right_ring_toe: { side: 'Back', name: 'Right Ring Toe' },
  right_little_toe: { side: 'Back', name: 'Right Little Toe' },
  left_plantar_foot_b: { side: 'Back', name: 'Left Plantar Foot (B)' },
  right_plantar_foot_b: { side: 'Back', name: 'Right Plantar Foot (B)' },
  left_heel: { side: 'Back', name: 'Left Heel' },
  right_heel: { side: 'Back', name: 'Right Heel' }
}


export const SWELLING = {
  around_right_eye: { side: 'Face', name: 'Around Right Eye' },
  around_left_eye: { side: 'Face', name: 'Around Left Eye' },
  right_cheekbone: { side: 'Face', name: 'Right Cheekbone' },
  left_cheekbone: { side: 'Face', name: 'Left Cheekbone' },
  tongue: { side: 'Face', name: 'Tongue' },
  lips_mouth: { side: 'Face', name: 'Lips/Mouth' },
  right_jaw: { side: 'Face', name: 'Right Jaw' },
  left_jaw: { side: 'Face', name: 'Left Jaw' },
  face: { side: 'Body', name: 'Face' },
  neck: { side: 'Body', name: 'Neck' },
  right_armpit: { side: 'Body', name: 'Right Armpit' },
  right_breast: { side: 'Body', name: 'Right Breast' },
  left_armpit: { side: 'Body', name: 'Left Armpit' },
  left_breast: { side: 'Body', name: 'Left Breast' },
  upper_abdomen: { side: 'Body', name: 'Upper Abdomen' },
  lower_abdomen: { side: 'Body', name: 'Lower Abdomen' },
  groin_area: { side: 'Body', name: 'Groin Area' },
  right_arm: { side: 'Body', name: 'Right Arm' },
  left_arm: { side: 'Body', name: 'Left Arm' },
  right_hand_fingers: { side: 'Body', name: 'Right Hand/Fingers' },
  left_hand_fingers: { side: 'Body', name: 'Left hand/Fingers' },
  right_leg_calf: { side: 'Body', name: 'Right Leg/Calf' },
  left_leg_calf: { side: 'Body', name: 'Left Leg/Calf' },
  right_foot: { side: 'Body', name: 'Right Foot' },
  left_foot: { side: 'Body', name: 'Left Foot' }
}

export default OLD
